import { Component, OnInit, Injectable } from '@angular/core'
import {FormGroup, FormBuilder} from '@angular/forms'
import {Router, ActivatedRoute, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router'
import { BaseComponent } from '../../../components/base.component'
import { CustomerActions } from '../../../actions/customer-actions'
import {Customer, Account} from '../../../types'
import {isAgencySignup} from '../../../utils'
import { additionalFields } from '../../../content/customer-content'
import sweetAlert from '../../../bmAlert'
import { Title } from '@angular/platform-browser'

@Component({
  selector: `other-info-page`,
  template: `
    <split-view>
      <div left>
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12 mt-3">
              <div class="nc-section-icon fas fa-comment"></div>
              <h1 class="nc-section-header">
                About {{ customer?.businessName }}
              </h1>

              <p *ngIf="!isAgencySignup()" class="top-buffer">Tell us about your business.</p>
              <p *ngIf="!isAgencySignup()" class="top-buffer">Your business and brand are unique. Tell us about your business so we can write blogs that fit your brand voice.</p>
              <p *ngIf="isAgencySignup()" class="top-buffer">Your client's business and brand are unique. Tell us about them so we can write blogs that fit their voice.</p>
              <about-nav [customer]="customer"></about-nav>
            </div>
          </div>
        </div>
      </div>
      <div right>
        <div class="container-fluid big-top-buffer">
          <div class="row">
            <div class="col-sm-12">
              <h2>Anything Else?</h2>
              <p class="top-buffer bottom-buffer">Help our writers understand what you're looking for in your content:</p>
            </div>
          </div>
          <div class="row bottom-buffer">
            <div class="col-sm-12">
              <form [formGroup]="form">
                <fieldset class="form-group">
                  <label for="contentExample">
                    {{isAgencySignup() ? 'An example of good content for ' + customer?.businessName + ' and why' : 'An example of your favorite content and why'}}:
                    <i class="fas fa-info-circle" [tooltip]="contentExampleTooltip" placement="left" container="body" containerClass="other-info-tooltip"></i>
                  </label>
                  <textarea id="contentExample" class="form-control" formControlName="contentExample" rows="6" [placeholder]="contentExamplePlaceholder"></textarea>
                </fieldset>
                <fieldset class="form-group">
                  <label for="otherInfo">
                    General business information for writers: <i class="fas fa-info-circle" [tooltip]="otherInfoTooltip" container="body" containerClass="white-tooltip"></i>
                  </label>
                  <textarea id="otherInfo" class="form-control" formControlName="otherInfo" rows="6" [placeholder]="otherInfoPlaceholder"></textarea>
                </fieldset>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="top-buffer bottom-buffer">
                <button (click)="updateCustomer()" class="block btn btn-primary mr-2">Continue to plan</button>
                <button (click)="next()" class="block btn btn-default">Skip for now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </split-view>
  `,
  styles: [`
    label i.fas {
      margin-left: 3px;
    }
  `]
})
export class OtherInfoPage extends BaseComponent implements OnInit {
  customer: Customer;
  customerId: number;
  account: Account;
  form: FormGroup;
  submitted: boolean = false;

  constructor(private route: ActivatedRoute,
    private fb: FormBuilder,
    private Router: Router,
    private customerActions: CustomerActions,
    private titleService: Title) {
    super()
  }

  ngOnInit(): void {
    this.titleService.setTitle('Sign Up - Additional Info')
    const routeObs = this.route.params.subscribe(params => {
      this.customerId = +params['customerId']
      this.customerActions.loadCustomer(this.customerId)

      // Fetch the customer and observe changes
      this.observeCustomer(this.customerId, c => {
        this.customer = c
        this.resetForm()
      })
    })
    this.observeAccount(a => this.account = a)
    this.observers.push(routeObs)
  }

  resetForm(): void {
    this.form = this.fb.group({
      contentExample: [this.customer ? this.customer.contentExample : '', null],
      otherInfo: [this.customer ? this.customer.otherInfo : '', null]
    })
  }

  updateCustomer(): void {
    this.submitted = true
    this.customerActions.updateCustomer(this.customerId, this.form.value).then(() => {
      this.next()
    })
  }

  next(): void {
    this.Router.navigate(['../../', this.customer?.multipass ? 'multipass-plan' : 'plan'], { relativeTo: this.route })
  }

  isAgencySignup(): boolean {
    return isAgencySignup(this.account)
  }

  contentExampleTooltip: string = additionalFields.contentExample.tip;
  contentExamplePlaceholder: string = additionalFields.contentExample.placeholder;
  otherInfoTooltip: string = additionalFields.otherInfo.tip;
  otherInfoPlaceholder: string = additionalFields.otherInfo.placeholder;
}

@Injectable()
export class CanDeactivateOtherInfoPage implements CanDeactivate<OtherInfoPage> {
  canDeactivate(component: OtherInfoPage, route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean>|boolean {
    if (component.form.dirty && !component.submitted) {
      return sweetAlert.confirm({text: "You have unsaved changes, are you sure you want to continue?"})
    } else {
      return true
    }
  }
}
